// Based on Feather Sprite Icons avaiable @ https://feathericons.com/
<template>
  <i>
    <svg class="feather" :width="width" :height="height">
      <use v-bind="{'xlink:href':'/feather-sprite.svg#'+name}"/>
    </svg>
  </i>  
</template>

<style scoped>
.feather {
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  margin-right: 5px;
}
</style>

<script>
export default {
  props: {
    name: String,
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 18
    }
  }
}
</script>
